import type { ControlProps } from './types';

const HEX = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;

export function ColorControl({ schema, value, disabled, onChange }: ControlProps) {
  const hex = typeof value === 'string' && HEX.test(value) ? value : '#000000';
  return (
    <span className="cf-control-group">
      <input
        type="color"
        aria-label={schema.label}
        value={hex}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
      />
      <input
        type="text"
        aria-label={`${schema.label} (hex)`}
        value={typeof value === 'string' ? value : hex}
        disabled={disabled}
        size={7}
        onChange={(e) => {
          if (HEX.test(e.target.value)) {
            onChange(e.target.value);
          }
        }}
      />
    </span>
  );
}
